import React, { useEffect } from "react";
import { useSignOut } from "../../../hooks/api/useSignOut";
import { useAuthStatusStore } from "../../../stepFlowHooks/useAuthStatusStore";
import { useSessionDataStore } from "../../../hooks/useSessionDataStore";
import { useAsyncEffect } from "use-async-effect";
import { StepFlowGate } from "../../Navigator/StepFlowGate";
import { StepId } from "../../../constants/navigation";
import { isNotEmptyString } from "../../../utils/commonUtils";

export const PostStreamingStep = () => {
    const { signOut, isSigningOut, response } = useSignOut();
    const onSignOut = useAuthStatusStore((store) => store.onSignOut);
    const setStreamingUrl = useSessionDataStore(
        (store) => store.setStreamingUrl
    );

    useAsyncEffect(async () => {
        onSignOut();
        setStreamingUrl(null);

        try {
            await signOut();
        } catch {
            // TODO [LOWA-30544] show error modal (or alert on sign-in page?)
        }
    }, []);

    useEffect(() => {
        if (isNotEmptyString(response?.Location)) {
            window.location.href = response.Location;
        }
    }, [response?.Location]);

    return (
        <StepFlowGate
            isCompleted={!isSigningOut && isNotEmptyString(response?.Location)}
            completedStepId={StepId.POST_STREAMING}
        />
    );
};
